import React, { FC } from 'react';

import { baseBlue, white } from '~src/styles/colors';

interface Props {
  color?: string;
  secondColor?: string;
}

const LLsLoader: FC<Props> = React.memo(({ color = white.a10, secondColor = baseBlue.a10 }) => (
  <svg
    className="loading_svg"
    xmlns="http://www.w3.org/2000/svg"
    width="800"
    height="800"
    viewBox="0 0 800 800"
  >
    <g fill="rgba(0,0,0,0)" fillRule="evenodd">
      <path
        strokeWidth="20"
        stroke={color}
        className="path"
        d="M 400 400 L 400 300 C 400 300 400 200 500 200 Q 600 200 600 300 C 600 300 600 400 500 400 L 400 400 L 300 400 C 300 400 200 400 200 500 Q 200 600 300 600 C 400 600 400 500 400 500 L 400 400"
      />
      <path
        strokeWidth="40"
        stroke={secondColor}
        className="second-path"
        d="M 400 390 L 400 300 C 400 300 400 200 500 200 Q 600 200 600 300 C 600 300 600 400 500 400 L 400 400 L 300 400 C 300 400 200 400 200 500 Q 200 600 300 600 C 400 600 400 500 400 500 L 400 400"
      />
      <path
        strokeWidth="20"
        stroke={color}
        className="circle"
        d="M 20 400 A 50 50 0 1 1 780 400 A 50 50 0 1 1 20 400 Z"
      />
      <path
        strokeWidth="40"
        stroke={secondColor}
        className="second-circle"
        d="M 20 400 A 50 50 0 1 1 780 400 A 50 50 0 1 1 20 400 Z"
      />
      <path
        strokeWidth="20"
        stroke={color}
        className="upper-path"
        d="M 20 400 A 50 50 0 1 1 780 400 A 50 50 0 1 1 20 400 Z"
      />
      <path
        strokeWidth="20"
        stroke={color}
        className="upper-path"
        d="M 400 400 L 400 300 C 400 300 400 200 500 200 Q 600 200 600 300 C 600 300 600 400 500 400 L 400 400 L 300 400 C 300 400 200 400 200 500 Q 200 600 300 600 C 400 600 400 500 400 500 L 400 400"
      />
    </g>
  </svg>
));

export default LLsLoader;
